export default __webpack_public_path__ + "static/media/hl2.2e34af08.png";